var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8V24C8 25.1046 8.89543 26 10 26H22C23.1046 26 24 25.1046 24 24V10.8284C24 10.298 23.7893 9.78929 23.4142 9.41421L20.5858 6.58579C20.2107 6.21071 19.702 6 19.1716 6H10C8.89543 6 8 6.89543 8 8Z",
    fill: "#73D1FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 17.3346C11.3334 16.9664 11.6319 16.668 12 16.668H12.6667C13.0349 16.668 13.3334 16.9664 13.3334 17.3346V21.3346H11.3334V17.3346Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.9987C15 11.6305 15.2985 11.332 15.6667 11.332H16.3333C16.7015 11.332 17 11.6305 17 11.9987V21.332H15V11.9987Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 14.6667C18.6666 14.2985 18.9651 14 19.3333 14H20C20.3681 14 20.6666 14.2985 20.6666 14.6667V21.3333H18.6666V14.6667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 6V6C19.7602 6 20.1696 6.16957 20.4714 6.4714L23.5286 9.5286C23.8305 9.83043 24 10.2398 24 10.6667V10.6667H21.3334C20.2288 10.6667 19.3334 9.77124 19.3334 8.66667V6Z",
    fill: "#3451D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.f5a8b2482f652cde3b25e9ddfb410e39.svg";
export { ForwardRef as ReactComponent };